// Models
import { createAboutUsWebpageStoreDefaultModel } from './about-us/about-us.store'
import { createAssessorWebpageStoreDefaultModel } from './assessor/assessor.store'
import { createContactUsWebpageStoreDefaultModel } from './contact-us/contact-us.store'
import { createGalleryWebpageStoreDefaultModel } from './gallery/gallery.store'
import { createHomeWebpageStoreDefaultModel } from './home-store/home.store'
import { createTukWebpageStoreDefaultModel } from './tuk/tuk.store'
import { createNewsWebpageStoreDefaultModel } from './news/news.store'

// Certification Models
import { createCertificationWebpageStoreDefaultModel, registration } from './certification'

const webpageModels = {
  aboutUsWebpage: createAboutUsWebpageStoreDefaultModel(),
  assessorWebpage: createAssessorWebpageStoreDefaultModel(),
  certificationWebpage: createCertificationWebpageStoreDefaultModel(),
  ...registration,
  contactUsWebpage: createContactUsWebpageStoreDefaultModel(),
  galleryWebpage: createGalleryWebpageStoreDefaultModel(),
  homeWebpage: createHomeWebpageStoreDefaultModel(),
  tukWebpage: createTukWebpageStoreDefaultModel(),
  newsWebpage: createNewsWebpageStoreDefaultModel(),
}

export { webpageModels }
